// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { mainNavigationStyles } from "@insite/content-library/Widgets/Header/MainNavigation";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

mainNavigationStyles.container = {
    css: css`
        color: ${getColor("common.background")};
        display: flex;
        justify-content: space-between;
        padding-right: 16px;
        flex-wrap: wrap;
    `,
};

mainNavigationStyles.itemWrapper = {
    css: css`
        position: relative;
        overflow: visible;
        display: flex;
        &:hover span + div {
            display: block;
        }

        &:first-child {
            margin-left: -20px;
        }
    `,
};

mainNavigationStyles.menuItem = {
    css: css`
        display: flex;
        align-items: center;
        height: 30px;
        padding: 0 20px;
    `,
};

mainNavigationStyles.menuItemIcon = {
    css: css`
        display: none; // no down arrows on navigation
    `,
};

mainNavigationStyles.menuItemTypography = {
    variant: "headerSecondary",
    color: "text.main",
    transform: "uppercase",
    size: 15,
    weight: 500,
    css: css`
        letter-spacing: 1px;
    `,
};

mainNavigationStyles.mobileSearchButton = {
    size: 48,
    buttonType: "solid",
    color: "white",
    css: css`
        padding: 0 10px;
        background: none !important;
        border: none;
        svg {
            color: white;
        }
    `,
};

mainNavigationStyles.mobileMenuWrapper = {
    css: css`
        button {
            border-radius: 0 !important;
        }
    `,
};
